import { QuizState } from "@/interfaces/sdk-quiz";
import { actions } from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state: QuizState = {
  quizzes: [],
  patterns: [],
  attachmentTypes: [],
};

export default {
  state,
  actions,
  getters,
  mutations,
};
